<script setup lang="ts">
import type { FooterContainerProps } from '#layers/uk/app/components/FooterContainer.vue'
import BaseFooterContainer from '#layers/uk/app/components/FooterContainer.vue'
import truelayerUrl from '#layers/uk/app/assets/payment/truelayer_stack.svg?url'
import visaUrl from '#layers/uk/app/assets/payment/visa.svg?url'
import mastercardUrl from '#layers/uk/app/assets/payment/mastercard.svg?url'
import applePayUrl from '#layers/uk/app/assets/payment/applepay-dark.svg?url'
import paypalUrl from '#layers/uk/app/assets/payment/paypal.svg?url'
import beGamblingAwareUrl from '#layers/uk/app/assets/authority/begambleaware.svg?url'
import eighteenPlusUrl from '#layers/uk/app/assets/authority/eighteen-plus.svg?url'

const props = defineProps<Pick<FooterContainerProps, 'enableTerms' | 'isLandingPage' | 'navigation'>>()
</script>

<template>
    <BaseFooterContainer
        v-bind="props"
        :payment="[
            {
                src: truelayerUrl,
                width: 50,
                height: 35,
            },
            {
                src: visaUrl,
                width: 50,
                height: 30,
            },
            {
                src: mastercardUrl,
                width: 38,
                height: 30,
            },
            {
                src: applePayUrl,
                width: 48,
                height: 30,
            },
            {
                src: paypalUrl,
                width: 78,
                height: 24,
            },
        ]"
        :authority="{
            items: [
                {
                    href: 'https://www.gamstop.co.uk/',
                    target: '_blank',
                    image: {
                        src: '/media/authority/gamstop.png',
                        height: 48,
                        width: 130,
                        alt: 'Gamstop'
                    },
                },
                {
                    href: 'https://registers.gamblingcommission.gov.uk/57641',
                    target: '_blank',
                    image: {
                        src: '/media/authority/gambling-authority.png',
                        height: 35,
                        width: 118,
                        alt: 'Gambling Commission'
                    },
                },
                {
                    href: '/safer-gambling',
                    image: {
                        src: eighteenPlusUrl,
                        height: 50,
                        width: 50,
                        alt: 'Eighteen plus'
                    },
                },
                {
                    href: 'https://www.begambleaware.org/',
                    image: {
                        src: beGamblingAwareUrl,
                        height: 25,
                        width: 120,
                        alt: 'Begambleaware'
                    },
                },
            ]
        }"
    />
</template>
